import { stat } from "fs";

const adplayerSearch = {
  state: {
    data: null
  },
  mutations: {
    SET_ADPLAYERSEARCH: (state, adplayerSearch) => {
      state.data = adplayerSearch
    }
  }
}

export default adplayerSearch



// WEBPACK FOOTER //
// ./src/store/modules/adplayerSearch.js